import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import * as Styled from "./grip-position-settings.style";
import { ConvertedNumberInput } from "ui/components/elements/input/converted-number-input";
import { useNumberConversionWithMillimeters } from "hooks/number-conversion";
import { actions, useAppDispatch } from "store";
import { GripPositionMarkerId } from "store/types";
import { defaultOvalGripPositionDiameterRatio, gripPositionMarkerModels, } from "3d/constants/common";
import { Unit } from "utility/number";
export var GripPositionSettings = function (_a) {
    var gripPosition = _a.gripPosition;
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var convertNumberWithMillimeters = useNumberConversionWithMillimeters();
    var gripPositionModel = gripPositionMarkerModels[gripPosition.marker];
    var markerSizeMinValue = gripPositionModel.diameterRange[0];
    var markerSizeMaxValue = gripPositionModel.diameterRange[1];
    var onChangeMarkerType = useCallback(function (value) {
        dispatch(actions.setGripPositionMarker({
            nodeId: gripPosition.nodeId,
            marker: value,
        }));
    }, [dispatch, gripPosition.nodeId]);
    var onChangeWidth = useCallback(function (width) {
        dispatch(actions.setGripPositionWidth({
            nodeId: gripPosition.nodeId,
            width: width,
        }));
    }, [dispatch, gripPosition.nodeId]);
    var onChangeOvalHeight = useCallback(function (height) {
        dispatch(actions.setGripPositionHeight({
            nodeId: gripPosition.nodeId,
            height: height,
        }));
    }, [dispatch, gripPosition.nodeId]);
    return (_jsxs(Styled.GripPositionSettingsRoot, { children: [_jsxs(Styled.NumberInputContainer, { children: [_jsx(ConvertedNumberInput, { useInputContainer: false, setValue: onChangeWidth, unit: Unit.M, min: markerSizeMinValue, max: markerSizeMaxValue, value: gripPosition.width, type: "float", customConverter: convertNumberWithMillimeters, instantUpdate: true, hideUnit: gripPosition.marker === GripPositionMarkerId.OVAL }), gripPosition.marker === GripPositionMarkerId.OVAL && (_jsxs(_Fragment, { children: [_jsx("span", { children: "x" }), _jsx(ConvertedNumberInput, { useInputContainer: false, setValue: onChangeOvalHeight, unit: Unit.M, min: markerSizeMinValue / defaultOvalGripPositionDiameterRatio, max: markerSizeMaxValue / defaultOvalGripPositionDiameterRatio, value: gripPosition.height, type: "float", customConverter: convertNumberWithMillimeters, instantUpdate: true, hideUnit: true }), _jsx("span", { children: Unit.MM })] }))] }), _jsxs(Styled.ImageContainer, { "aria-label": t("edit_grip_position.marker_type_label"), children: [_jsx(MarkerIdSelect, { markerId: GripPositionMarkerId.CIRCLE, selectedMarkerId: gripPosition.marker, onChangeMarkerType: onChangeMarkerType }), _jsx(MarkerIdSelect, { markerId: GripPositionMarkerId.OVAL, selectedMarkerId: gripPosition.marker, onChangeMarkerType: onChangeMarkerType })] })] }));
};
var MarkerIdSelect = function (_a) {
    var markerId = _a.markerId, selectedMarkerId = _a.selectedMarkerId, onChangeMarkerType = _a.onChangeMarkerType;
    return (_jsx(Styled.SelectableImage, { role: "button", tabIndex: 0, selected: selectedMarkerId === markerId, src: selectedMarkerId === markerId
            ? gripPositionMarkerModels[markerId].imageActive
            : gripPositionMarkerModels[markerId].image, onClick: function () { return onChangeMarkerType(markerId); }, onKeyDown: function (e) {
            if (e.key === "Enter" || e.key === " ") {
                onChangeMarkerType(markerId);
                e.preventDefault();
            }
        } }));
};
